import { appStorage } from './betaStorage'
export interface AustralianTimeZoneOption {
  value: string
  label: string
}

export const AUSTRALIAN_TIME_ZONES: AustralianTimeZoneOption[] = [
  { value: 'Australia/Perth', label: 'Western Australia — Perth' },
  { value: 'Australia/Eucla', label: 'Western Australia — Eucla' },
  { value: 'Australia/Darwin', label: 'Northern Territory — Darwin' },
  { value: 'Australia/Adelaide', label: 'South Australia — Adelaide' },
  { value: 'Australia/Brisbane', label: 'Queensland — Brisbane' },
  { value: 'Australia/Sydney', label: 'New South Wales / ACT — Sydney' },
  { value: 'Australia/Broken_Hill', label: 'New South Wales — Broken Hill' },
  { value: 'Australia/Melbourne', label: 'Victoria — Melbourne' },
  { value: 'Australia/Hobart', label: 'Tasmania — Hobart' },
  { value: 'Australia/Lord_Howe', label: 'Lord Howe Island' },
  { value: 'Indian/Christmas', label: 'Christmas Island' },
  { value: 'Indian/Cocos', label: 'Cocos (Keeling) Islands' },
  { value: 'Pacific/Norfolk', label: 'Norfolk Island' },
]

const TIME_ZONE_KEY = 'schub.timeZone'
export const DEFAULT_AUSTRALIAN_TIME_ZONE = 'Australia/Melbourne'

export function getAustralianTimeZone(): string {
  const stored = appStorage.getItem(TIME_ZONE_KEY)
  return AUSTRALIAN_TIME_ZONES.some((zone) => zone.value === stored)
    ? stored!
    : DEFAULT_AUSTRALIAN_TIME_ZONE
}

export function setAustralianTimeZone(timeZone: string) {
  if (!AUSTRALIAN_TIME_ZONES.some((zone) => zone.value === timeZone)) return
  appStorage.setItem(TIME_ZONE_KEY, timeZone)
  window.dispatchEvent(new CustomEvent('schub:timezone-change', { detail: timeZone }))
}

export function formatTime12Hour(time: string): string {
  const match = /^(\d{1,2}):(\d{2})$/.exec(time.trim())
  if (!match) return time

  const hour = Number(match[1])
  const minute = Number(match[2])
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return time

  const suffix = hour >= 12 ? 'PM' : 'AM'
  const displayHour = hour % 12 || 12
  return `${displayHour}:${String(minute).padStart(2, '0')} ${suffix}`
}

/** Converts standalone 24-hour clock values while leaving ISO timestamps and already-formatted AM/PM times alone. */
export function formatClockText12Hour(text: string): string {
  return text.replace(/(^|[^\dT])([01]\d|2[0-3]):([0-5]\d)(?!:\d|\d|\s*(?:AM|PM)\b)/gi, (_match, prefix, hour, minute) => {
    return `${prefix}${formatTime12Hour(`${hour}:${minute}`)}`
  })
}

